export enum TaxTypes {
  SIMPLE = 'simple',
  GENERAL = 'general',
}
